<template>
    <div class="plan-other">
        <div class="row mt-4">
            <div :class="isBeneficiaries()" >
                <div class="card border-0">
                    <div class="card-header">
                        <span>
                             Plan Details
                        </span>
                    </div>
                    <div class="card-body gray-bg">
                        <ul v-if="false" class="list-group">
                            <li class="list-group-item border-top-0 border-right-0 border-left-0 ml-1 mr-1 pr-2 pl-2 pb-2 pt-2 mr-2">
                                <div class="row">
                                    <div class="col-md-6 sb-benefit-main-list-title pl-4">
                                        Plan Name
                                    </div>
                                    <div class="col-md-6 text-right sb-benefit-main-list-value">
                                        {{ healthplanD.planname }}
                                    </div>
                                </div>
                            </li>
                            <li class="list-group-item border-top-0 border-right-0 border-left-0 ml-1 mr-1 pr-2 pl-2 pb-2 pt-2 mr-2">
                                <div class="row">
                                    <div class="col-md-6 sb-benefit-main-list-title pl-4">
                                        Group Number
                                    </div>
                                    <div class="col-md-6 text-right sb-benefit-main-list-value">
                                        {{ healthplanD.groupnum }}
                                    </div>
                                </div>
                            </li>
                            <li class="list-group-item border-top-0 border-right-0 border-left-0 ml-1 mr-1 pr-2 pl-2 pb-2 pt-2 mr-2">
                                <div class="row">
                                    <div class="col-md-6 sb-benefit-main-list-title pl-4">
                                        Coverage Amount
                                    </div>
                                    <div class="col-md-6 text-right sb-benefit-main-list-value">
                                        ${{ healthplanD.coverage }}
                                    </div>
                                </div>
                            </li>
                            <li class="list-group-item border-top-0 border-right-0 border-left-0 ml-1 mr-1 pr-2 pl-2 pb-2 pt-2 mr-2" v-if="healthplanD.supplemental_amount">
                                <div class="row">
                                    <div class="col-md-6 sb-benefit-main-list-title pl-4">
                                        Supplemental Amount
                                    </div>
                                    <div class="col-md-6 text-right sb-benefit-main-list-value">
                                        ${{healthplanD.supplemental_amount}}
                                    </div>
                                </div>
                            </li>
                            <li v-for="field in getHpSummaryFields(healthplanD.hpd_fields)"
                                class="list-group-item card-notes__other border-top-0 border-right-0 border-left-0 ml-1 mr-1 pr-2 pl-2 pb-2 mr-2"
                            >
                                <div v-if="field.label === 'Notes'">
                                    <div class="card-notes ">
                                        <div class="card-notes-title pt-2">NOTES:</div>
                                        <div class="card-notes-text mb-3" v-html="field.value"></div>
                                    </div>
                                </div>
                                <div v-else-if="field.value !== '' && [1,3].includes(field.highlight)"
                                     class="row"
                                >
                                    <div class="col-md-6 sb-benefit-main-list-title pl-4">
                                        {{ field.label }}
                                    </div>
                                    <div :class="field.value=='THE PLAN PAYS'?'col-md-6 text-right sb-benefit-main-list-value font-weight-bold':'col-md-6 text-right sb-benefit-main-list-value'">
                                        {{ field.type == 'currency' ? '$' : '' }}{{ field.value === '' ? '&nbsp' : field.value }}{{ field.type === 'percent' ? '%' : '' }}
                                    </div>
                                </div>
                            </li>
                            <li v-if="healthplanD.note" class="border-bottom-0 list-group-item card-notes__other border-top-0 border-right-0 border-left-0 ml-1 mr-1 pr-2 pl-2 pb-2 pt-2 mr-2">
                                <div class="card-notes" v-if="healthplanD.note">
                                    <div class="card-notes-title pt-2">NOTES:</div>
                                    <div class="card-notes-text" v-html="healthplanD.note"></div>
                                </div>
                            </li>
                        </ul>
                        <ul v-else class="list-group">
                            <div v-for="parentfield in this.healthplanD.hpd_fields">
                                <li v-if="parentfield.fieldtype === 'heading'" class="border-bottom-0 list-group-item card-notes__other border-top-0 border-right-0 border-left-0 ml-1 mr-1 pr-2 pl-2 pb-2 mr-2">
                                    <div class="pb-0">
                                        <div class="card-notes-title pt-2 pb-1 text-uppercase pl-2">
                                            {{ parentfield.label }}:
                                        </div>
                                    </div>
                                </li>
                                <div v-if="parentfield.children.length > 0"
                                     v-for="subfield in parentfield.children"
                                >
                                    <template>
                                        <li v-if="subfield.fieldtype === 'heading3'"
                                            class="list-group-item border-top-0 border-bottom-0 border-right-0 border-left-0 ml-1 mr-1 pr-2 pl-4 pb-2 pt-2 mr-2"
                                        >
                                            <div class="row">
                                                <div class="col-md-12 sb-benefit-main-list-title pl-4 text-uppercase">
                                                    {{ subfield.label }}
                                                </div>
                                            </div>
                                        </li>
                                        <li v-else-if="showSubfield(subfield)"
                                            class="list-group-item border-top-0 border-right-0 border-left-0 ml-1 mr-1 pr-2 pl-2 pb-2 pt-2 mr-2"
                                        >
                                            <div class="row">
                                                <div class="col-md-7 sb-benefit-main-list-title pl-4">
                                                    {{ subfield.label }}
                                                </div>
                                                <div class="col-md-5 text-right sb-benefit-main-list-value">
                                                    {{ subfield.type == 'currency' ? '$' : '' }}{{ subfield.value }}{{ subfield.type === 'percent' ? '%' : '' }}
                                                </div>
                                            </div>
                                        </li>
                                        <li v-if="subfield.children.length > 0"
                                            v-for="(sub,key) in subfield.children"
                                            :class="key+1==subfield.children.length?'list-group-item border-bottom-1 border-top-0 border-right-0 border-left-0 ml-0 pt-2 pr-0':'list-group-item border-bottom-0 border-top-0 border-right-0 border-left-0 ml-0 pt-2 pr-0'"
                                        >
                                            <template v-if="showSub(sub)">
                                                <div class="row  mr-2" v-if="sub.fieldtype === 'heading3'">
                                                    <div class="col-md-6 sb-benefit-main-list-title pb-2 text-uppercase">
                                                        {{ sub.value }}
                                                    </div>
                                                </div>
                                                <div class="row  mr-0" v-else>
                                                    <div class="col-md-8 sb-benefit-main-list-title pl-4">
                                                        {{ sub.label }}
                                                    </div>
                                                    <div class="col-md-4 text-right sb-benefit-main-list-value">
                                                        {{ sub.type == 'currency' ? '$' : '' }}{{ sub.value }}{{ sub.type === 'percent' ? '%' : '' }}
                                                    </div>
                                                </div>
                                                <ul v-for="subsub in sub.children"
                                                    class="list-group pr-2" v-if="sub.children.length>0"
                                                >
                                                    <li class="list-group-item border-top-0 border-left-0 border-right-0 sb-benefit-sublist-value pt-2 pb-2"
                                                        v-if="subsub.value !== ''"
                                                    >
                                                        <div class="row">
                                                            <div class="col-md-8 sb-benefit-main-sublist-title pl-0">
                                                                {{ subsub.label }}
                                                            </div>
                                                            <div class="col-md-4 text-right sb-benefit-main-list-value pr-1">
                                                                {{ subsub.type == 'currency' ? '$' : '' }}{{ subsub.value }}{{ subsub.type === 'percent' ? '%' : '' }}
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </template>
                                        </li>
                                    </template>
                                </div>

                            </div>
                            <li v-if="healthplanD.note" class="border-bottom-0 list-group-item card-notes__other border-top-0 border-right-0 border-left-0 ml-1 mr-1 pr-2 pl-2 pb-2 mr-2">
                                <div class="card-notes">
                                    <div class="card-notes-title pt-2">NOTES:</div>
                                    <div class="card-notes-text" v-html="healthplanD.note"></div>
                                </div>
                            </li>
                        </ul>

                        <div class="card-forms">
                            <div class="card-forms-title pt-1">FORMS & BROCHURES</div>
                            <div class="card-forms-link flex-column">
                                <a
                                    v-for="fb in healthplanD.hpd_fb"
                                    :href="fb.value"
                                    class="pl-0"
                                    :title="fb.name"
                                    :target="fb.name=='Decrease or Cancel Coverage'?'_self':'_blank'"
                                >
                                    {{ fb.name }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6" v-if="beneficiariesLength">
                <div class="card border-0">
                    <div class="card-header">
                        <span>
                            Beneficiaries
                        </span>
                    </div>
                    <div class="card-body gray-bg">

                        <ul class="list-group pr-2" v-if="beneficiariesLength">
                            <div v-for="beneficiary in healthplanD.beneficiaries">
                                <li v-if="dontShowBen" class="list-group-item border-top-0 border-right-0 border-left-0 ml-1 mr-1 pr-2 pl-2 pb-2 pt-2 mr-2">
                                    <div class="row">
                                        <div class="col-md-6 sb-benefit-main-list-title pl-4">
                                            BENEFICIARY
                                        </div>
                                        <div class="col-md-6 text-right sb-benefit-main-list-value">
                                            {{beneficiary.first_name}} {{beneficiary.last_name}}
                                        </div>
                                    </div>
                                </li>
                                <li v-if="dontShowBen" class="list-group-item border-top-0 border-right-0 border-left-0 ml-1 mr-1 pr-2 pl-2 pb-2 pt-2 mr-2">
                                    <div class="row sb-benefit-child-row">
                                        <div class="col-md-6 sb-benefit-main-list-title pl-4 font-weight-bold">
                                            Beneficiary Type
                                        </div>
                                        <div class="col-md-6 text-right sb-benefit-main-list-value">
                                            {{beneficiary.type}}
                                        </div>
                                    </div>
                                    <div class="row sb-benefit-child-row">
                                        <div class="col-md-6 sb-benefit-main-list-title pl-4  font-weight-bold">
                                            Beneficiary Relationship
                                        </div>
                                        <div class="col-md-6 text-right sb-benefit-main-list-value">
                                            {{beneficiary.relation}}
                                        </div>
                                    </div>
                                    <div class="row sb-benefit-child-row">
                                        <div class="col-md-6 sb-benefit-main-list-title pl-4  font-weight-bold">
                                            Beneficiary %
                                        </div>
                                        <div class="col-md-6 text-right sb-benefit-main-list-value">
                                            {{beneficiary.beneficiary_percent}}
                                        </div>
                                    </div>
                                </li>
                            </div>
                            <li v-if="!dontShowBen" class="list-group-item border-top-0 border-right-0 border-left-0 ml-1 mr-1 pr-2 pl-2 pb-2 pt-2 mr-2">
                                <div class="row sb-benefit-child-row">
                                    <div class="font-italic col-md-12 sb-benefit-main-list-value">
                                        We are working on getting all of your account information loaded, including beneficiary information. This may take up to two business days. Stay tuned!
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <!--                        <div class="card-notes">-->
                        <!--                            <div class="card-notes-title">NOTES:</div>-->
                        <!--                            <div class="card-notes-text"><p>Out-of-network providers may balance bill you for the difference between what the plan pays and their actual fee.</p>-->
                        <!--                            <p>This is a summary of the features of the Compass Rose Health Plan. All benefits are subject to the definitions, limitations and exclusions set forth in the FEHB Plan Brochure.</p></div>-->
                        <!--                        </div>-->
                    </div>
                </div>
            </div>
        </div>
        <plan-contacts :contacts="healthplanD.hpc" :title="contactsTitle()"></plan-contacts>
    </div>
</template>

<script>
import _ from "lodash";
import PlanContacts from "./PlanContacts";

export default {
    name: "PlanOther",
    components: {PlanContacts},
    props: ['healthplanD'],
    data() {
        return {
            dontShowBen:true,
            showMore: false,
            beneficiariesLength: this.healthplanD.beneficiaries.length
        }
    },
    computed: {
        chevronDirection() {
            return this.showMore ? 'fa-chevron-up' : 'fa-chevron-down';
        }
    },
    methods: {
        getWebsite(healthplan){
            return _.filter(healthplan.hpc,{type:"website"})[0].website.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split('/')[0];
        },
        getHpSummaryFields(fields) {
            let data = [];
            data = [...data, ...this.findField(fields, 'Effective Date')];
            data = [...data, ...this.findField(fields, 'Premium Amount')];
            data = [...data, ...this.findField(fields, 'IF THIS OCCURS')];
            data = [...data, ...this.findField(fields, 'Loss of Life')];
            data = [...data, ...this.findField(fields, 'Loss of Both Hands/Feet')];
            data = [...data, ...this.findField(fields, 'Loss of Sight in Both Eyes')];
            data = [...data, ...this.findField(fields, 'Loss of One Hand & One Foot')];
            data = [...data, ...this.findField(fields, 'Loss of One Hand & Sight in One Eye')];
            data = [...data, ...this.findField(fields, 'Loss of One Foot & Sight in One Eye')];
            data = [...data, ...this.findField(fields, 'Loss of Speech and Hearing in Both Ears')];
            data = [...data, ...this.findField(fields, 'Loss of One Hand')];
            data = [...data, ...this.findField(fields, 'Loss of One Foot')];
            data = [...data, ...this.findField(fields, 'Loss of Sight in One Eye')];
            data = [...data, ...this.findField(fields, 'Loss of Speech or Hearing in Both Ears')];
            data = [...data, ...this.findField(fields, 'Loss of Thumb & Index Finger on the Same Hand')];
            data = [...data, ...this.findField(fields, 'Loss of Hearing in One Ear')];
            data = [...data, ...this.findField(fields, 'Notes')];
            return data
        },
        findField(fields, label) {
            let data = [];
            _.forEach(fields, (value, key) => {
                if (
                    value.label == label
                ) {
                    data.push(value);
                }
                if (value.children.length > 0) {
                    data = [...data, ...this.findField(value.children, label)];
                }
            })
            return _.take(data, 1);
        },
        isBeneficiaries(){
            return this.beneficiariesLength ? "col-md-6" : "col-md-12";
        },
        contactsTitle() {
            return this.healthplanD.planname + " Contact Information"
        },
        showSub(sub) {
            if (sub.value !== '')
                return true;

            return !!sub.children.find(c => c.value !== '');
        },
        showSubfield(sub) {
            if (sub.value !== '')
                return true;

            return !!sub.children.find(c => this.showSub(c));
        },
        sortChildren(array){
            return array.sort((a, b) => a.order - b.order);
        }
},
}
</script>

<style scoped>

</style>
